<template>
  <div class="common-steps">
    <ul>
      <li v-for="(item, index) in list" :key="index" class="__flex __flex-vc">
        <section class="slot-left __col-8">
          <p class="__fs-16 year">{{item.year}}- </p>
          <p class="__ta-right __fs-10">
            <span v-show="item.month">{{item.month >= 10 ? item.month: '0' + item.month}}</span>
            <span v-show="item.month && item.day">-</span>
            <span v-show="item.day">{{item.day >= 10 ? item.day : '0' + item.day}}</span>
          </p>
        </section>
        <section class="step">
          <van-image
            class="step-img"
            :src="require('@/assets/images/icon/step_key.png')"
          />
          <div
            :class="['step-line', {'half-end': index === 0}, {'half-start':index === list.length -1}]"
          >
          </div>
        </section>
        <section @click="cbDetail(item)" class="slot-right __flex __flex-vc __bc-f">
          <div id="triangle-left"></div>
          <div>
            <van-image
              v-if="item.listImg"
              class="news-img"
              :src="formatAliyunPath(item.listImg)"
            />
          </div>
          <div class="content __flex __flex-cb">
            <p :class="[item.listImg? 'active': '']" class="title __line1 __fs-17">{{item.title}}</p>
            <p class="summary __ellipsis __line2 __cor-8">{{item.summary}}</p>
          </div>
        </section>
      </li>
    </ul>
  </div>
</template>

<script>
import { aliyun } from '@/agent'
export default {
  name: 'CommonSteps',
  props: {
    list: {
      type: Array,
    },
  },
  data () {
    return {}
  },
  methods: {
    cbDetail (item) {
      // this.$router.push({ path: '/news/detail' })
      this.$emit('cb-detail', item)
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    },
  },
}
</script>

<style lang="scss" scoped>
.common-steps {
  width: 100%;
  margin-top: 20px;
  ul {
    li {
      height: 108px;
      .slot-left {
        align-self: center;
        width: 48px !important;
        margin-right: 12px;
        overflow-x: hidden;
        .year {
          margin-bottom: 10px;
        }
      }
      .step {
        position: relative;
        display: flex;
        align-items: flex-end;
        height: 100%;
        .step-img {
          position: absolute;
          top: 54px;
          left: -3px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
        }
        .step-line {
          height: 100%;
          border: 1px solid #ccc;
          &.half-end {
            align-self: flex-end;
            height: 50px;
          }
          &.half-start {
            align-self: flex-start;
            height: 54px;
          }
        }
      }
      .slot-right {
        width: 100%;
        overflow-x: hidden;
        box-sizing: border-box;
        height: 88px;
        padding: 0 15px;
        margin-left: 14px;
        position: relative;
        #triangle-left {
          position: absolute;
          left: -8px;
          top: 38px;
          width:0;
          height:0;
          border-top: 8px solid transparent;
          border-right: 8px solid #fff;
          border-bottom: 8px solid transparent;
        }
        .news-img {
          width: 83px;
          height: 62px;
          flex-shrink: 0;
          margin-right: 10px;
        }
        .content {
          flex-direction: column;
          height: 62px;
          .title {
            width: 237px;
            margin-top: -4px;
            &.active {
              width: 144px;
            }
          }
        }
      }
    }
  }
}
</style>
